import {Drawer, IconButton, Menu as MuiMenu} from '@mui/material';
import styled from 'styled-components';
import {media} from '../../../theme/breakpoints';
import {StyledButton} from './components/ConversationItem.styled';

interface OpenProps {
    open: boolean;
}

// Todo: The mainColor should be defined in a single place, f.e. inside global css file.
const mainColor = '#1d2a41';

export const SidebarContainer = styled(Drawer)`
    font-size: 14px;
    font-family: 'Manrope', sans-serif;

    .MuiDrawer-paper {
        width: ${(props) => (props.open ? 'auto' : '70px')};
        max-width: 290px;
        transition: width 0.3s;
        overflow-x: hidden;
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: ${(props) => (props.open ? 'flex-end' : 'center')};
        padding: 24px ${(props) => (props.open ? '24px' : '11px')} 16px;
        background: #FFFFFF;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.04);
        scrollbar-width: none;

        @media (max-width: 959px) {
            width: 290px;
            max-width: 290px;
        }
    }
`;

export const StyledIconButton = styled(IconButton)`

    img {
        width: 16px;
        height: 11px;
        border: 2px solid ${mainColor};
    }
`;

export const SidebarHeader = styled.div<{ $isOpen?: boolean }>`
    display: flex;
    justify-content: ${({$isOpen}) => ($isOpen ? 'space-between' : 'center')};
    align-items: center;
    width: 100%;
    height: 28px;
    margin-bottom: 40px;
`;

export const SidebarContent = styled.div<OpenProps>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
    flex-grow: 1;
    overflow: hidden;
    width: 100%;

    @media (max-width: 959px) {
        overflow-y: auto;
        overflow-x: hidden;
        scrollbar-width: thin;
        scrollbar-color: rgba(29, 42, 65, 0.6) transparent;

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-track {
            background: transparent;
        }

        &::-webkit-scrollbar-thumb {
            background-color: rgba(29, 42, 65, 0.6);
            border-radius: 10px;
        }
    }
`;

export const ConversationHistorySection = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow: hidden;
    width: 100%;
    min-height: 0;
    margin-top: 8px;

    @media (max-width: 959px) {
        overflow: visible;
    }
`;

export const LogoBox = styled.div`
    //width: 180px;
    //height: 40px;
    margin-top: 10px;

    img {
        width: 140px;
    }
`;

export const StyledReportProblemWrapper = styled.div<OpenProps>`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    padding: 0;
    gap: 20px;
    //width: 240px;
    height: auto;
    margin-top: 20px;
`;

export const StyledReportProblemButton = styled(StyledButton)`
    background: #E0E0E0;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    position: relative;
    top: 1px;

    &:hover {
        background: #d0d0d0;
    }

    svg {
        width: 20px;
        height: 20px;
    }
`;

export const StyledNewRequestButtonContent = styled.div<{ $active?: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0;
    gap: 16px;
    width: 100%;
    height: 24px;

    div {
        margin-left: 0;
        color: ${({$active}) => $active ? 'white' : mainColor};
    }

    svg {
        width: 21px;
        height: 21px;
        position: relative;
        top: 2px;
    }

    span {
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        display: flex;
        align-items: center;
        color: ${({$active}) => $active ? '#FAFAFA' : mainColor};
    }
`;

export const StyledNewRequestButton = styled(StyledButton)<{ $active?: boolean }>`
    background: ${({$active}) => $active ? mainColor : 'transparent'};
    border-radius: 20px;

    &:hover {
        background: ${({$active}) => $active ? '#152033' : '#f0f0f0'};
    }
`;

export const PanelAdminButton = styled(StyledButton)`
    border-radius: 20px;
    padding: 8px;
    font-size: 16px;

    &:hover {
        background: #e6e6e6;
    }
`;

export const Divider = styled.div`
    height: 1px;
    width: 100%;
    border: 1px solid ${mainColor};
    margin: 16px 0;
`;

export const ProfileContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0;
    gap: 10px;
    width: 100%;
    height: 40px;

    img {
        width: 40px;
        height: 40px;
        border-radius: 40px;
    }
`;

export const ProfileMoreBtn = styled(IconButton)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0;
    gap: 4px;
    width: 28px;
    height: 28px;
    border-radius: 12px;

    img {
        width: 4px;
        height: 20px;
    }
`;

export const ConversationList = styled.div<OpenProps>`
    width: ${(props) => (props.open ? '240px' : '50px')};
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(29, 42, 65, 0.6) transparent;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;

    &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background-color: rgba(29, 42, 65, 0.6);
        border-radius: 10px;
    }

    &::-webkit-scrollbar-button {
        width: 0;
        height: 0;
        display: none;
    }

    &::-webkit-scrollbar-corner {
        background: transparent;
    }

    @media (max-width: 959px) {
        overflow: visible;
    }
`;

export const StyledSectionHeader = styled.div`
    width: 100%;
    font-weight: 700;
    font-size: 14px;
    line-height: 19px;
    color: #262626;
    margin-bottom: 8px;
    margin-top: 5px;
`;

export const ProjectsHeader = styled.div`
    font-weight: 700;
    font-size: 18px;
    color: #262626;
    margin: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

export const AllDataSourcesButton = styled.button`
    font-size: 12px;
    font-weight: 600;
    color: ${mainColor};
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 16px;
    transition: background-color 0.2s, opacity 0.2s;

    &:hover {
        background-color: #eef2f9;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        background-color: transparent;
    }
`;

export const HistoryHeader = styled.div`
    height: auto;
    font-weight: 700;
    font-size: 18px;
    color: #262626;
    margin: 0 0 16px 0;
    width: 100%;
`;

export const ProjectItem = styled.button`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 5px;
    gap: 8px;
    width: 100%;
    height: 34px;
    border-radius: 20px;
    margin-bottom: 10px;
    border: none;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const ProjectName = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0;
    gap: 16px;
    height: 24px;
    font-weight: 700;
    line-height: 19px;
    color: #262626;
    width: 100%;
    font-size: 13px;

    img {
        width: 24px;
        height: 24px;
        border: 2px solid ${mainColor};
    }
`;

export const OptionsIcon = styled.div`
    width: 16px;
    height: 16px;
    background: #262626;
    border: 1px solid #262626;
`;

export const MaterialsButton = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0;
    gap: 16px;
    width: 100%;
    height: 24px;
    margin-bottom: 4px;

    img {
        width: 24px;
        height: 24px;
        border: 2px solid ${mainColor};
    }

    span {
        font-weight: 400;
        font-size: 14px;
        line-height: 19px;
        display: flex;
        align-items: center;
        color: #262626;
    }
`;

export const ReportsButton = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0;
    gap: 16px;
    width: 100%;
    height: 24px;

    img {
        width: 24px;
        height: 24px;
        border: 2px solid ${mainColor};
    }

    span {
        font-weight: 400;
        font-size: 14px;
        line-height: 19px;
        display: flex;
        align-items: center;
        color: #262626;
    }
`;

export const StyledMenu = styled(MuiMenu)`
    .MuiPaper-root {
        border-radius: 8px;
    }
`;

export const MobileMenuButton = styled.button`
    position: fixed;
    top: 24px;
    left: 24px;
    z-index: 1300;
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: #F5F5F5;
    }

    &:active {
        transform: scale(0.95);
    }

    svg {
        width: 24px;
        height: 24px;
        color: ${mainColor};
    }

    ${media.md} {
        display: none;
    }
`;
